import { Action } from '@ngrx/store';
import { ProjectWithStatsResponse } from './project';
import { IdPayload } from '../shared/domain/IdPayload';
import { Configuration } from '../shared/domain/configuration.model';
import { ChangeProjectActivity } from './models/ChangeProjectActivity';
import { CreateProjectResponse } from '../shared/models/Project';
import { UpdateStyleRequest } from '../shared/domain/UpdateStyleRequest';

export const GET_PROJECTS_WITH_STATS = 'GET_PROJECTS_WITH_STATS';
export const GET_PROJECTS_WITH_STATS_SUCCESS = 'GET_PROJECTS_WITH_STATS_SUCCESS';
export const GET_PROJECTS_WITH_STATS_FAILURE = 'GET_PROJECTS_WITH_STATS_FAILURE';
export const GET_PROJECT = 'GET_PROJECT';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE';
export const UPDATE_PROJECT_CONFIGURATION = 'UPDATE_PROJECT_CONFIGURATION';
export const UPDATE_PROJECT_CONFIGURATION_SUCCESS = 'UPDATE_PROJECT_CONFIGURATION_SUCCESS';
export const UPDATE_PROJECT_CONFIGURATION_FAILURE = 'UPDATE_PROJECT_CONFIGURATION_FAILURE';
export const UPDATE_PROJECT_STYLE = 'UPDATE_PROJECT_STYLE';
export const UPDATE_PROJECT_STYLE_SUCCESS = 'UPDATE_PROJECT_STYLE_SUCCESS';
export const UPDATE_PROJECT_STYLE_FAILURE = 'UPDATE_PROJECT_STYLE_FAILURE';
export const CHANGE_ACTIVITY = 'CHANGE_ACTIVITY';
export const CHANGE_ACTIVITY_SUCCESS = 'CHANGE_ACTIVITY_SUCCESS';
export const CHANGE_ACTIVITY_FAILURE = 'CHANGE_ACTIVITY_FAILURE';
export const CLEAR_PROJECT = 'CLEAR_PROJECT';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';
export const REMOVE_PROJECT_SUCCESS = 'REMOVE_PROJECT_SUCCESS';
export const REMOVE_PROJECT_FAILURE = 'REMOVE_PROJECT_FAILURE';
export const SAVE_CREATED_PROJECT_SNAPSHOT = 'SAVE_CREATED_PROJECT_SNAPSHOT';

export const CREATE_DEFAULT_CONFIGURATION = 'CREATE_DEFAULT_CONFIGURATION';
export const CREATE_DEFAULT_CONFIGURATION_SUCCESS = 'CREATE_DEFAULT_CONFIGURATION_SUCCESS';
export const CREATE_DEFAULT_CONFIGURATION_FAILURE = 'CREATE_DEFAULT_CONFIGURATION_FAILURE';

export class GetProjectsWithStatsAction implements Action {
  readonly type = GET_PROJECTS_WITH_STATS;

  constructor(public payload?: any) {}
}

export class GetProjectsWithStatsSuccessAction implements Action {
  readonly type = GET_PROJECTS_WITH_STATS_SUCCESS;

  constructor(public payload: ProjectWithStatsResponse[]) {}
}

export class GetProjectsWithStatsFailureAction implements Action {
  readonly type = GET_PROJECTS_WITH_STATS_FAILURE;

  constructor(public payload: any) {}
}

export class GetProjectAction implements Action {
  readonly type = GET_PROJECT;

  constructor(public payload: IdPayload) {}
}

export class GetProjectSuccessAction implements Action {
  readonly type = GET_PROJECT_SUCCESS;

  constructor(public payload: Configuration) {}
}

export class GetProjectFailureAction implements Action {
  readonly type = GET_PROJECT_FAILURE;

  constructor(public payload: any) {}
}

export class CreateProjectAction implements Action {
  readonly type = CREATE_PROJECT;

  constructor(public payload: Configuration) {}
}

export class CreateProjectSuccessAction implements Action {
  readonly type = CREATE_PROJECT_SUCCESS;

  constructor(public payload: CreateProjectResponse) {}
}

export class CreateProjectFailureAction implements Action {
  readonly type = CREATE_PROJECT_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateProjectConfigurationAction implements Action {
  readonly type = UPDATE_PROJECT_CONFIGURATION;

  constructor(public payload: Configuration) {}
}

export class UpdateProjectConfigurationSuccessAction implements Action {
  readonly type = UPDATE_PROJECT_CONFIGURATION_SUCCESS;

  constructor(public payload: Configuration) {}
}

export class UpdateProjectConfigurationFailureAction implements Action {
  readonly type = UPDATE_PROJECT_CONFIGURATION_FAILURE;

  constructor(public payload: Error) {}
}

export class RemoveProjectAction implements Action {
  readonly type = REMOVE_PROJECT;

  constructor(public payload: number) {}
}

export class RemoveProjectSuccessAction implements Action {
  readonly type = REMOVE_PROJECT_SUCCESS;

  constructor() {}
}

export class RemoveProjectFailureAction implements Action {
  readonly type = REMOVE_PROJECT_FAILURE;

  constructor(public payload) {}
}

export class UpdateProjectStyleAction implements Action {
  readonly type = UPDATE_PROJECT_STYLE;

  constructor(public payload: UpdateStyleRequest) {}
}

export class UpdateProjectStyleSuccessAction implements Action {
  readonly type = UPDATE_PROJECT_STYLE_SUCCESS;

  constructor(public payload: Configuration) {}
}

export class UpdateProjectStyleFailureAction implements Action {
  readonly type = UPDATE_PROJECT_STYLE_FAILURE;

  constructor(public payload: any) {}
}

export class ChangeActivityAction implements Action {
  readonly type = CHANGE_ACTIVITY;

  constructor(public payload: ChangeProjectActivity) {}
}

export class ChangeActivitySuccessAction implements Action {
  readonly type = CHANGE_ACTIVITY_SUCCESS;

  constructor(public payload: ChangeProjectActivity) {}
}

export class ChangeActivityFailureAction implements Action {
  readonly type = CHANGE_ACTIVITY_FAILURE;

  constructor(public payload) {}
}

export class CreateDefaultConfigurationAction implements Action {
  readonly type = CREATE_DEFAULT_CONFIGURATION;

  constructor(public payload: Configuration) {}
}

export class CreateDefaultConfigurationSuccessAction implements Action {
  readonly type = CREATE_DEFAULT_CONFIGURATION_SUCCESS;

  constructor(public payload: Configuration) {}
}

export class CreateDefaultConfigurationFailureAction implements Action {
  readonly type = CREATE_DEFAULT_CONFIGURATION_FAILURE;

  constructor(public payload: any) {}
}

export class ClearProjectAction implements Action {
  readonly type = CLEAR_PROJECT;

  constructor(public payload: Configuration) {}
}

export class SaveCreatedProjectSnapshotAction implements Action {
  readonly type = SAVE_CREATED_PROJECT_SNAPSHOT;

  constructor(public payload: Configuration) {}
}

export type ProjectsAction =
  | GetProjectsWithStatsAction
  | GetProjectsWithStatsSuccessAction
  | GetProjectsWithStatsFailureAction
  | GetProjectAction
  | GetProjectSuccessAction
  | GetProjectFailureAction
  | CreateProjectAction
  | CreateProjectSuccessAction
  | CreateProjectFailureAction
  | UpdateProjectConfigurationAction
  | UpdateProjectConfigurationSuccessAction
  | UpdateProjectConfigurationFailureAction
  | UpdateProjectStyleAction
  | UpdateProjectStyleSuccessAction
  | UpdateProjectStyleFailureAction
  | ChangeActivityAction
  | ChangeActivitySuccessAction
  | ChangeActivityFailureAction
  | ClearProjectAction
  | RemoveProjectAction
  | RemoveProjectSuccessAction
  | RemoveProjectFailureAction
  | CreateDefaultConfigurationAction
  | CreateDefaultConfigurationSuccessAction
  | CreateDefaultConfigurationFailureAction
  | SaveCreatedProjectSnapshotAction;
